import React from 'react';

import {ODDS_TYPES, ODDS_TYPES_TERMS} from "../components/odds-consts";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {AppTerms} from "../../../app/app-terms";
import {UseTerms} from "../../composers/composer-plugins/use-terms";
import {UseDevice} from "../../composers/composer-plugins/use-device";
import {DeviceViewModel} from "../../../models/device.view-model";
import {List} from "../../misc/list/list";
import {OddsTypeDropdownItem} from "./odds-type-dropdown.item";
import {Tooltip, TooltipProps} from "../../tooltip/tooltip";
import {ThreeDotsHorizontal} from "../../../icons/three-dots-horizontal";
import {TOOLTIP_PLACEMENT, TOOLTIP_TRIGGER} from "../../tooltip/tooltip-consts";
import {ODDS_TYPE_DROPDOWN} from "./odds-type-dropdow.consts";

export class OddsTypeDropdownProps extends BaseProps {
  onOddsChange: Function;
  isOpen: Boolean;
  selectedOddsType: ODDS_TYPES;
  i18n: AppTerms;
  device: DeviceViewModel;
}

export const OddsTypeDropdown = UseDevice()(UseTerms()((props: OddsTypeDropdownProps) => {
  const buttonsProps = Object.values(ODDS_TYPES).map((oddType: ODDS_TYPES) => {
    return {
      id: oddType,
      key: oddType,
      name: props.i18n[ODDS_TYPES_TERMS[oddType]],
      onClick: () => props.onOddsChange(oddType),
      active: oddType === props.selectedOddsType
    };
  });

  const menuContentProps = {
    className: 'odds-type-dropdown-list',
    items: buttonsProps,
    ListItem: OddsTypeDropdownItem
  };

  const tooltipProps: TooltipProps = {
    trigger: TOOLTIP_TRIGGER.click,
    placement: TOOLTIP_PLACEMENT.bottom,
    distance: ODDS_TYPE_DROPDOWN.tooltipDistance,
    interactive: true,
    ignoreDeviceWidth: true,
    hideArrow: true,
    content: <List {...menuContentProps} />,
  };

  return (
    <div className={'odds-type-dropdown'}>
      <Tooltip title={props.i18n.WEB_TOOLTIP_ODDS_SETTINGS}>
        <Tooltip {...tooltipProps}>
          <ThreeDotsHorizontal className={'odds-type-dropdown-three-dots'}/>
        </Tooltip>
      </Tooltip>
    </div>
  )
}));
